export enum SurveyImageType {
  Email,
  ThankyouMessage,
}

export enum SurveyDeliveryMethod {
  SharableLink,
  Email,
  Either,
}

export enum SurveyImagePosition {
  Left,
  Centre,
  Right,
}

export enum SurveyQuestionType {
  None = -1,
  NumberRating = 0,
  SingleText = 1,
  Comment = 2,
  MultipleChoiceCheckbox = 3,
  MultipleChoiceRadio = 4,
  EmailAddress = 5,
  Dropdown = 6,
  Location = 7,
  Acel = 8,
  MultiQuestion = 9,
  Number = 10,
}
